import React from 'react';
import SideBar from './sidebar';

class AccountStatement extends React.Component {

  render() {
    return (    
      <div className="bg-alabaster">
        <div className="container-account-statement row pl-15 pr-15" data-text="ES">
          <SideBar />
          <div className="col-12 col-lg-9 container-body p-0 mb-15">
            <div className="col-12 mt-30"> 
              <h2 className="d-inline"><i className="fas fa-arrow-left icon-dashboard d-none"></i>Estado de Cuenta</h2>
            </div>
            <p className="subtitle mt-15">Te invitamos a conocer las transacciones que se han registrado en tu Cuenta Corporativa en los últimos 12 meses. Selecciona a continuación un periodo</p>
            <form className="form-corp" id="cpr-stm-pda-frm-fcp" data-parsley-validate="" noValidate="">
              <div className="row mt-15 pb-15 card-basic account" id="cpr-stm-pda-div-acc">
                <div className="col-md-6 col-12 mt-15">
                  <h5>Desde:</h5>
                  <div className="row mt-15 pb-15">
                    <div className="col-md-6 pl-0 group-month-from" id="cpr-stm-pda-div-gmf" data-text="Sólo se permiten consultas de meses previos">
                      <div className="form-group form-group-dropdown mb-0">
                        <label className="select-label">Mes</label>                         
                        <select
                          type="text" 
                          className="month-from custom-select" 
                          data-parsley-errors-container="#cpr-stm-pda-div-gmf"
                          data-parsley-trigger="input focus"
                          required
                          data-parsley-required-message="Campo requerido"
                        >
                        </select>                        
                      </div> 
                      <div className="input-group-append">
                        <span className="input-group-text valid"><i className="fas fa-check-circle"></i></span>
                        <span className="input-group-text invalid"><i className="fas fa-times-circle"></i></span>
                      </div> 
                    </div>
                    <div className="col-md-6 pl-0" id="cpr-stm-pda-div-gyf">
                      <div className="form-group form-group-dropdown mb-0">
                        <label className="select-label">Año</label>                         
                        <select
                          type="text" 
                          className="year-from custom-select" 
                          data-parsley-errors-container="#cpr-stm-pda-div-gyf"
                          data-parsley-trigger="input focus"
                          required
                          data-parsley-required-message="Campo requerido"
                        >
                        </select>                        
                      </div> 
                      <div className="input-group-append">
                        <span className="input-group-text valid"><i className="fas fa-check-circle"></i></span>
                        <span className="input-group-text invalid"><i className="fas fa-times-circle"></i></span>
                      </div>                  
                    </div> 
                  </div>
                </div>
                <div className="col-md-6 col-12 mt-15">
                  <h5>Hasta:</h5>
                  <div className="row mt-15 pb-15">
                      <div className="col-md-6 pl-0" id="cpr-stm-pda-div-gmu">
                        <div className="col-md-12 pl-0 group-month-current" id="cpr-stm-pda-div-gmc" data-text="Texto prueba para validar mes Actual">
                          <div className="form-group form-group-dropdown mb-0">
                            <label className="select-label">Mes</label>                         
                            <select
                              type="text" 
                              className="month-until custom-select" 
                              data-parsley-errors-container="#cpr-stm-pda-div-gmu"                            
                              data-parsley-errors-container="#cpr-stm-pda-div-gmc"
                              data-parsley-trigger="input focus"
                              required
                              data-parsley-required-message="Campo requerido"
                            >
                            </select>                        
                          </div> 
                          <div className="input-group-append">
                            <span className="input-group-text valid"><i className="fas fa-check-circle"></i></span>
                            <span className="input-group-text invalid"><i className="fas fa-times-circle"></i></span>
                          </div> 
                        </div>                    
                      </div>
                    <div className="col-md-6 pl-0" id="cpr-stm-pda-div-gyu">
                      <div className="form-group form-group-dropdown mb-0">
                        <label className="select-label">Año</label>                         
                        <select
                          type="text" 
                          className="year-until custom-select" 
                          data-parsley-errors-container="#cpr-stm-pda-div-gyu"
                          data-parsley-trigger="input focus"
                          required
                          data-parsley-required-message="Campo requerido"
                        >
                        </select>                        
                      </div> 
                      <div className="input-group-append">
                        <span className="input-group-text valid"><i className="fas fa-check-circle"></i></span>
                        <span className="input-group-text invalid"><i className="fas fa-times-circle"></i></span>
                      </div>                  
                    </div> 
                  </div>  
                </div>
                <div className="row w-100" >         
                <div className="col-12 text-right">
                  <div className="col-12 col-md-6">
                    <div className="modal fade modal-export" id="exportModal" tabindex="-1" role="dialog" aria-labelledby="exportModalLabel" aria-hidden="true">
                      <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h4 className="modal-title text-center">Selecciona el formato en el que deseas exportar tu Estado de Cuenta</h4>
                          </div>
                          <div className="modal-body my-4">
                            <div id="modal-content">
                              <div className="text-center">
                                <div className="custom-control custom-radio custom-control-inline mr-md-4">
                                  <input className="custom-control-input input-pdf" id="cpr-stm-exp-inp-pdf" name="cpr-stm-exp-rad" type="radio" value="PDF" defaultChecked="checked" />
                                  <label className="custom-control-label" htmlFor="cpr-stm-exp-inp-pdf">Archivo PDF</label>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                  <input className="custom-control-input input-xls" id="cpr-stm-exp-inp-xls" name="cpr-stm-exp-rad" type="radio" value="XLS" />
                                  <label className="custom-control-label" htmlFor="cpr-stm-exp-inp-xls">Archivo Excel</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer d-flex justify-content-center align-items-center modal-buttons">
                            <button className="btn btn-secondary mr-md-4 order-2 order-md-1" id="cpr-stm-exp-btn-cnl" type="button" data-dismiss="modal">Cancelar</button>
                            <button className="btn btn-primary export-data order-1 order-md-2" id="cpr-stm-exp-btn-exp">Exportar archivo</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-secondary btn-export mr-15 mt-15 d-none" id="cpr-stm-pda-btn-exp" data-text="Exportar archivo" data-toggle="modal" data-target="#exportModal">
                    Exportar
                  </button>
                  <button className="btn btn-primary btn-consult mt-15" data-text="Consultar" disabled id="cpr-stm-pda-btn-con">
                    Consultar
                  </button>
                </div>                  
                </div>               
              </div> 
            </form>
            <div className="alert alert-danger alert-table-error mt-30 d-none" role="alert">
              <div className="row row-basic pl-15">
                <i className='fas fa-times-circle'/>
                <h5>Información incorrecta</h5>
                <i className="close fas fa-times" data-dismiss="alert"/>    
              </div>
              <div className="row row-basic row-table-alert pl-15 alert-text">
                <p className="text"></p>
              </div>
            </div>
            <div className="row container-table-statement d-none  mt-15 pb-15 card-basic" data-url="https://corporativo.clubpremier.info/corporate-statement/generate">
              <div className="table-statement-export  col-md-8 col-9 title" data-url="https://corporativo.clubpremier.info/corporate-statement/export">
                <h3 className="mt-15">Transacciones realizadas</h3>
              </div>
              <div className="col-12 col-lg-12">
                <table className="table table-striped table-statement -main" id="cpr-stm-pda-tbl-tst">
                  <thead>
                    <tr>
                      <th scope="col"><h6 className="mb-0">Fecha de Acred/Reden</h6></th>
                      <th scope="col"><h6 className="mb-0">Fecha de Actividad</h6></th>
                      <th scope="col"><h6 className="mb-0">Empresa afiliada</h6></th>
                      <th scope="col"><h6 className="mb-0">Descripción</h6></th>
                      <th scope="col"><h6 className="mb-0">Puntos Premier</h6></th>
                      <th scope="col"><h6 className="mb-0">Puntos Calificables</h6></th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
        {/* Vista Dummie */}
        <div className="container-account-statement row pl-15 pr-15 view-statement-tutorial d-none" data-info=""> 
        <input className="tutorial-url" type="hidden" id="cpr-stm-pda-inp-tur" value="https://120f9306-f69f-4320-9c49-ae35b8453518.mock.pstmn.io/api/v1/tutorials/statement"/> 
        <input className="redirect-url" type="hidden" id="cpr-stm-pda-inp-rur" value="http://localhost:3000/home_member"/> 
        <input className="link-tutorial" type="hidden" id="cpr-stm-pda-inp-ltt" value="false"/>
          <div className="col-12 col-lg-3 d-none d-lg-block container-sidebar-homem sidebar-tutorial">
            <div className="sidebar pt-40 bg-bismark">
              <header className="row mb-15">
                <div className="col-3">
                  <div className="avatar-circle">
                    <div className="avatar-circle-2">
                      <div className="notification">
                        <span className="notification-text">
                          <p>VS</p>
                        </span>   
                      </div>
                      <div className="circle-2">
                      </div>
                      <div className="circle-3">
                      </div>
                      <div className="circle-4">
                      </div>  
                    </div>
                  </div>
                </div>    
                <div className="container-data col-9 pr-0">
                  <div className="name-data">
                    <p>Nombre Apellido Paterno</p>
                  </div>
                  <div className="company-data">
                    <p>Empresa: </p>
                    <p>TRANSPORTES RAMOS DEL SUR</p>
                  </div>
                  <div className="account-data">
                    <p>No de Cuenta: </p>
                    <p>00970001483</p>
                  </div>
                  <div className="title">
                    <p>Representante de Cuenta</p>
                  </div>
                </div>
              </header>
              <ul className="nav">
                <li >
                  <a >
                    <div className="image">
                      <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="path" d="M19.375 13H2.5V1.125C2.5 0.779687 2.22031 0.5 1.875 0.5H0.625C0.279687 0.5 0 0.779687 0 1.125V14.25C0 14.9402 0.559766 15.5 1.25 15.5H19.375C19.7203 15.5 20 15.2203 20 14.875V13.625C20 13.2797 19.7203 13 19.375 13ZM18.125 1.75H13.5133C12.6781 1.75 12.2598 2.75977 12.8504 3.35039L14.116 4.61602L11.25 7.48242L8.38398 4.61641C7.8957 4.12813 7.1043 4.12813 6.61641 4.61641L3.9332 7.29961C3.68906 7.54375 3.68906 7.93945 3.9332 8.18359L4.8168 9.06719C5.06094 9.31133 5.45664 9.31133 5.70078 9.06719L7.5 7.26758L10.366 10.1336C10.8543 10.6219 11.6457 10.6219 12.1336 10.1336L15.8836 6.38359L17.1492 7.64922C17.7398 8.23984 18.7496 7.82148 18.7496 6.98633V2.375C18.75 2.02969 18.4703 1.75 18.125 1.75Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left">
                      <p>Dashboard</p>
                    </div>             
                  </a>
                </li>
                <li >
                  <a >
                    <div className="image">
                      <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="path" d="M9.5 4.0625C7.46976 4.0625 5.82258 5.74219 5.82258 7.8125C5.82258 9.88281 7.46976 11.5625 9.5 11.5625C11.5302 11.5625 13.1774 9.88281 13.1774 7.8125C13.1774 5.74219 11.5302 4.0625 9.5 4.0625ZM9.5 9.6875C8.48488 9.6875 7.66129 8.84766 7.66129 7.8125C7.66129 6.77734 8.48488 5.9375 9.5 5.9375C10.5151 5.9375 11.3387 6.77734 11.3387 7.8125C11.3387 8.84766 10.5151 9.6875 9.5 9.6875ZM9.5 0.3125C4.25202 0.3125 0 4.64844 0 10C0 15.3516 4.25202 19.6875 9.5 19.6875C14.748 19.6875 19 15.3516 19 10C19 4.64844 14.748 0.3125 9.5 0.3125ZM9.5 17.8125C7.59617 17.8125 5.85706 17.0977 4.51633 15.9219C5.0871 15.0234 6.06391 14.4141 7.18246 14.3789C7.97923 14.6289 8.7377 14.7539 9.5 14.7539C10.2623 14.7539 11.0208 14.6328 11.8175 14.3789C12.9361 14.418 13.9129 15.0234 14.4837 15.9219C13.1429 17.0977 11.4038 17.8125 9.5 17.8125ZM15.7325 14.5273C14.7978 13.3008 13.3536 12.5 11.7065 12.5C11.3157 12.5 10.7105 12.875 9.5 12.875C8.29335 12.875 7.68427 12.5 7.29355 12.5C5.6502 12.5 4.20605 13.3008 3.26754 14.5273C2.37117 13.25 1.83871 11.6875 1.83871 10C1.83871 5.69141 5.2748 2.1875 9.5 2.1875C13.7252 2.1875 17.1613 5.69141 17.1613 10C17.1613 11.6875 16.6288 13.25 15.7325 14.5273Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left">
                      <p>Perfil Corporativo</p>
                    </div>             
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                      <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="path" d="M14.6786 3.82324L11.3492 0.545898C10.9921 0.194336 10.5079 -0.00488281 10.004 -0.00488281H1.90476C0.853175 -0.000976562 0 0.838867 0 1.87402V18.124C0 19.1592 0.853175 19.999 1.90476 19.999H13.3333C14.3849 19.999 15.2381 19.1592 15.2381 18.124V5.15137C15.2381 4.65527 15.0357 4.1748 14.6786 3.82324ZM13.1786 4.99902H10.1587V2.02637L13.1786 4.99902ZM1.90476 18.124V1.87402H8.25397V5.93652C8.25397 6.45606 8.67857 6.87402 9.20635 6.87402H13.3333V18.124H1.90476Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left">
                      <p>Estado de Cuenta</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                      <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="path" d="M18.3299 0.256836H1.67014C0.746528 0.256836 0 1.0127 0 1.94434V14.3193C0 15.251 0.746528 16.0068 1.67014 16.0068H18.3299C19.2535 16.0068 20 15.251 20 14.3193V1.94434C20 1.0127 19.2535 0.256836 18.3299 0.256836ZM1.87847 1.94434H18.1215C18.2361 1.94434 18.3299 2.03926 18.3299 2.15527V3.63184H1.67014V2.15527C1.67014 2.03926 1.76389 1.94434 1.87847 1.94434ZM18.1215 14.3193H1.87847C1.76389 14.3193 1.67014 14.2244 1.67014 14.1084V8.13184H18.3299V14.1084C18.3299 14.2244 18.2361 14.3193 18.1215 14.3193ZM6.66667 10.8037V12.21C6.66667 12.442 6.47917 12.6318 6.25 12.6318H3.75C3.52083 12.6318 3.33333 12.442 3.33333 12.21V10.8037C3.33333 10.5717 3.52083 10.3818 3.75 10.3818H6.25C6.47917 10.3818 6.66667 10.5717 6.66667 10.8037ZM13.3333 10.8037V12.21C13.3333 12.442 13.1458 12.6318 12.9167 12.6318H8.19444C7.96528 12.6318 7.77778 12.442 7.77778 12.21V10.8037C7.77778 10.5717 7.96528 10.3818 8.19444 10.3818H12.9167C13.1458 10.3818 13.3333 10.5717 13.3333 10.8037Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left">
                      <p>Tarjetas y membresías</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                      <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="path" d="M19.0801 10.6683C19.1614 10.227 19.1614 9.77625 19.0801 9.33491L19.8865 8.86854C19.9802 8.81533 20.0209 8.70577 19.9896 8.60248C19.7802 7.9264 19.4208 7.31291 18.952 6.80584C18.8801 6.72759 18.7645 6.70881 18.6707 6.76202L17.8644 7.2284C17.5237 6.9373 17.1331 6.71194 16.7111 6.5617V5.62895C16.7111 5.52253 16.6361 5.42863 16.533 5.40672C15.836 5.25021 15.1266 5.25647 14.464 5.40672C14.3609 5.42863 14.2859 5.52253 14.2859 5.62895V6.5617C13.864 6.71194 13.4733 6.9373 13.1326 7.2284L12.3263 6.76202C12.2357 6.70881 12.1169 6.72759 12.045 6.80584C11.5762 7.31291 11.2168 7.9264 11.0074 8.60248C10.9762 8.70577 11.0199 8.81533 11.1105 8.86854L11.9169 9.33491C11.8356 9.77625 11.8356 10.227 11.9169 10.6683L11.1105 11.1347C11.0168 11.1879 10.9762 11.2974 11.0074 11.4007C11.2168 12.0768 11.5762 12.6872 12.045 13.1974C12.1169 13.2756 12.2325 13.2944 12.3263 13.2412L13.1326 12.7748C13.4733 13.0659 13.864 13.2913 14.2859 13.4415V14.3743C14.2859 14.4807 14.3609 14.5746 14.464 14.5965C15.161 14.753 15.8704 14.7467 16.533 14.5965C16.6361 14.5746 16.7111 14.4807 16.7111 14.3743V13.4415C17.1331 13.2913 17.5237 13.0659 17.8644 12.7748L18.6707 13.2412C18.7614 13.2944 18.8801 13.2756 18.952 13.1974C19.4208 12.6903 19.7802 12.0768 19.9896 11.4007C20.0209 11.2974 19.9771 11.1879 19.8865 11.1347L19.0801 10.6683ZM15.5016 11.5197C14.664 11.5197 13.9858 10.8373 13.9858 10.0016C13.9858 9.16589 14.6672 8.48354 15.5016 8.48354C16.3361 8.48354 17.0174 9.16589 17.0174 10.0016C17.0174 10.8373 16.3392 11.5197 15.5016 11.5197ZM3.00032 6.99677C4.10356 6.99677 5.00053 6.09845 5.00053 4.99355C5.00053 3.88865 4.10356 2.99033 3.00032 2.99033C1.89708 2.99033 1.00011 3.88865 1.00011 4.99355C1.00011 6.09845 1.89708 6.99677 3.00032 6.99677ZM10.0011 7.99839C10.0604 7.99839 10.1167 7.98274 10.1761 7.97961C10.4355 7.30039 10.8168 6.66186 11.3106 6.12663C11.5418 5.87622 11.87 5.73224 12.2138 5.73224C12.4294 5.73224 12.642 5.78858 12.8264 5.89813L13.0733 6.04211C13.0983 6.02646 13.1233 6.01394 13.1483 5.99829C13.367 5.54131 13.4983 5.03424 13.4983 4.49588C13.4983 2.55838 11.9325 0.990234 9.99793 0.990234C8.06335 0.990234 6.50069 2.55525 6.50069 4.49275C6.50069 6.43024 8.06647 7.99839 10.0011 7.99839ZM13.2889 14.0863C13.217 14.0487 13.1451 14.0049 13.0764 13.9642C12.8201 14.1145 12.5982 14.271 12.2169 14.271C11.8763 14.271 11.5481 14.127 11.3137 13.8766C10.7418 13.2568 10.3042 12.5025 10.0573 11.6981C9.7229 10.6182 10.8355 10.1425 10.8636 10.1237C10.8605 10.0423 10.8605 9.96092 10.8636 9.87954L10.6167 9.73556C10.498 9.6667 10.398 9.57906 10.3105 9.48202C10.2073 9.48828 10.1073 9.5008 10.0042 9.5008C9.23535 9.5008 8.51652 9.313 7.86333 9H7.60393C5.61309 9 4.00042 10.6151 4.00042 12.6058V13.5073C4.00042 14.3367 4.67237 15.0097 5.50058 15.0097H13.4827C13.367 14.8219 13.2889 14.609 13.2889 14.3743V14.0863ZM5.40995 8.58057C5.04741 8.22062 4.55048 7.99839 4.00042 7.99839H2.00021C0.89697 7.99839 0 8.89671 0 10.0016V11.0032C0 11.5572 0.446922 12.0048 1.00011 12.0048H3.0597C3.25659 10.5212 4.15044 9.27231 5.40995 8.58057Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left">
                      <p>Representantes y contactos</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                      <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="path" d="M14.0938 0H3.9375C3.77176 0 3.61277 0.0658594 3.49559 0.183086L0.683086 2.99559C0.565859 3.11277 0.5 3.27172 0.5 3.4375V18.5938C0.5 19.3692 1.13082 20 1.90625 20H14.0938C14.8692 20 15.5 19.3692 15.5 18.5938V1.40625C15.5 0.63082 14.8692 0 14.0938 0ZM4.19637 1.25H4.5625V3.90625C4.5625 3.99242 4.49242 4.0625 4.40625 4.0625H1.75V3.69637L4.19637 1.25ZM14.25 18.5938C14.25 18.6799 14.1799 18.75 14.0938 18.75H1.90625C1.82008 18.75 1.75 18.6799 1.75 18.5938V5.3125H4.40625C5.18168 5.3125 5.8125 4.68168 5.8125 3.90625V1.25H14.0938C14.1799 1.25 14.25 1.32008 14.25 1.40625V18.5938Z" fill="#ABBFCC"/>
                        <path className="path" d="M10.5 12.5C10.5 11.1215 9.37848 10 7.99996 10C7.3107 10 6.74996 9.43926 6.74996 8.75C6.74996 8.06074 7.3107 7.5 7.99996 7.5C8.61312 7.5 9.13144 7.9377 9.23238 8.5407C9.28941 8.88113 9.61172 9.11098 9.95199 9.05395C10.2924 8.99699 10.5222 8.67477 10.4652 8.33434C10.2986 7.33875 9.56457 6.56875 8.625 6.32875V5.9375C8.625 5.59234 8.34519 5.3125 8 5.3125C7.6548 5.3125 7.375 5.59234 7.375 5.9375V6.3291C6.29793 6.60734 5.5 7.58723 5.5 8.75C5.5 10.1285 6.62148 11.25 8 11.25C8.68926 11.25 9.25 11.8107 9.25 12.5C9.25 13.1893 8.68926 13.75 8 13.75C7.38684 13.75 6.86852 13.3123 6.76758 12.7093C6.71059 12.3689 6.38836 12.1389 6.04797 12.1961C5.70754 12.253 5.47773 12.5752 5.53473 12.9157C5.70137 13.9112 6.43539 14.6813 7.37496 14.9213V15.3125C7.37496 15.6577 7.65476 15.9375 7.99996 15.9375C8.34516 15.9375 8.62496 15.6577 8.62496 15.3125V14.9209C9.70203 14.6427 10.5 13.6628 10.5 12.5Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left">
                      <p>Acreditaciones retroactivas</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#cpr-stm-pda-cpp-clp)">
                        <path className="path" d="M18.674 19.3426L17.1539 4.86709C17.122 4.56405 16.8666 4.33395 16.5619 4.33395H13.7048V3.68255C13.7048 1.65207 12.0528 0 10.0223 0C7.99165 0 6.33959 1.65207 6.33959 3.68255V4.33395H3.48254C3.17782 4.33395 2.92239 4.56405 2.8905 4.86709L1.37042 19.3426C1.35287 19.5103 1.40735 19.6777 1.52011 19.8031C1.63302 19.9284 1.79385 20 1.96246 20H18.0818C18.2506 20 18.4114 19.9284 18.5242 19.8031C18.6372 19.6777 18.6916 19.5103 18.674 19.3426ZM7.53008 3.68255C7.53008 2.3085 8.64809 1.19049 10.0223 1.19049C11.3963 1.19049 12.5144 2.3085 12.5144 3.68255V4.33395H7.53008V3.68255ZM2.62347 18.8095L4.01858 5.52443H6.33959V6.83623C6.33959 7.1649 6.60616 7.43147 6.93483 7.43147C7.26351 7.43147 7.53008 7.1649 7.53008 6.83623V5.52443H12.5144V6.83623C12.5144 7.1649 12.7809 7.43147 13.1096 7.43147C13.4383 7.43147 13.7048 7.1649 13.7048 6.83623V5.52443H16.0258L17.421 18.8095H2.62347Z" fill="#ABBFCC"/>
                        <path className="path" d="M13.498 11.943C13.474 11.869 13.4101 11.8151 13.3332 11.804L11.172 11.4899L10.2055 9.53157C10.1711 9.46185 10.1001 9.41772 10.0223 9.41772C9.9446 9.41772 9.8736 9.46185 9.8392 9.53157L8.87262 11.4899L6.71149 11.804C6.63457 11.8151 6.57065 11.869 6.54663 11.943C6.52259 12.0169 6.54264 12.0981 6.59831 12.1523L8.16209 13.6767L7.79298 15.8292C7.77983 15.9058 7.81134 15.9832 7.87423 16.0289C7.90981 16.0548 7.95195 16.0679 7.9943 16.0679C8.02681 16.0679 8.05943 16.0602 8.08931 16.0445L10.0223 15.0282L11.9553 16.0445C12.0241 16.0806 12.1075 16.0746 12.1704 16.0289C12.2333 15.9832 12.2648 15.9058 12.2516 15.8291L11.8824 13.6767L13.4464 12.1523C13.502 12.0981 13.5221 12.0169 13.498 11.943Z" fill="#ABBFCC"/>
                      </g><defs><clipPath id="cpr-stm-pda-cpp-clp"><rect width="20" height="20" fill="white"/></clipPath></defs>
                    </svg>
                    </div>
                    <div className="content text-left">
                      <p>Compras de Puntos Premier</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                      <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="path" d="M17.5249 11.2222H7.34625L7.57351 12.3333H16.8936C17.4283 12.3333 17.8247 12.8299 17.7062 13.3513L17.5146 14.1942C18.1636 14.5093 18.6111 15.1746 18.6111 15.9444C18.6111 17.0278 17.725 17.9043 16.6381 17.8887C15.6025 17.8738 14.7509 17.0334 14.723 15.9981C14.7077 15.4326 14.9342 14.92 15.3064 14.5555H8.02695C8.38726 14.9085 8.61111 15.4002 8.61111 15.9444C8.61111 17.049 7.69 17.9385 6.57396 17.8867C5.58299 17.8407 4.77705 17.04 4.72497 16.0493C4.68476 15.2842 5.08733 14.6099 5.69896 14.2581L3.25983 2.33331H0.833333C0.37309 2.33331 0 1.96022 0 1.49997V0.944417C0 0.484174 0.37309 0.111084 0.833333 0.111084H4.39337C4.78924 0.111084 5.13045 0.389591 5.20979 0.777403L5.52806 2.33331H19.1663C19.7011 2.33331 20.0974 2.82987 19.9789 3.35133L18.3375 10.5736C18.2513 10.953 17.914 11.2222 17.5249 11.2222ZM13.9941 6.77775H12.5V4.69442C12.5 4.46431 12.3134 4.27775 12.0833 4.27775H11.25C11.0199 4.27775 10.8333 4.46431 10.8333 4.69442V6.77775H9.33927C8.96806 6.77775 8.78215 7.22657 9.04465 7.48904L11.372 9.81643C11.5348 9.97914 11.7986 9.97914 11.9613 9.81643L14.2887 7.48904C14.5512 7.22657 14.3653 6.77775 13.9941 6.77775Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left">
                      <p>Recuperar Puntos Premier</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="path" d="M19.8833 7.26586L17.84 4.54152L17.9198 3.98359C17.9458 3.80102 17.8845 3.6168 17.754 3.48641L16.5111 2.24344L17.754 1.00047C17.9828 0.77168 17.9828 0.400664 17.754 0.171836C17.5252 -0.0569531 17.1542 -0.0569531 16.9254 0.171836L15.6824 1.4148L14.4395 0.171836C14.3091 0.0414062 14.1249 -0.0197656 13.9423 0.00609374L8.14177 0.834727C8.01626 0.852656 7.89997 0.91082 7.81032 1.00047L0.62876 8.18203C-0.208936 9.01969 -0.208936 10.3827 0.62876 11.2204L6.70544 17.2971C6.82974 17.4214 6.96583 17.5268 7.10985 17.6142V17.8518C7.10985 19.0364 8.07364 20.0002 9.25829 20.0002H17.852C19.0367 20.0002 20.0005 19.0364 20.0005 17.8518V7.61742C20.0005 7.49066 19.9593 7.36727 19.8833 7.26586ZM1.45739 10.3918C1.07661 10.011 1.07661 9.39145 1.45739 9.01066L8.50083 1.96723L13.8179 1.20766L14.8538 2.24348L14.0251 3.07211L13.6108 2.65777C13.382 2.42898 13.011 2.42898 12.7822 2.65777C12.5533 2.88656 12.5533 3.25758 12.7822 3.48641L14.4395 5.14371C14.5539 5.25813 14.7038 5.31535 14.8538 5.31535C15.0037 5.31535 15.1537 5.25813 15.2681 5.14371C15.4969 4.91492 15.4969 4.54391 15.2681 4.31508L14.8537 3.90074L15.6824 3.07211L16.7182 4.10793L15.9586 9.42504L8.91517 16.4685C8.73071 16.6529 8.48548 16.7545 8.22462 16.7545C7.96376 16.7545 7.71853 16.6529 7.53407 16.4685L1.45739 10.3918ZM18.8286 17.8518C18.8286 18.3903 18.3905 18.8284 17.852 18.8284H9.25829C8.74407 18.8284 8.32173 18.4288 8.28466 17.9239C8.81462 17.9092 9.34021 17.7007 9.74376 17.2971L16.9253 10.1155C17.015 10.0259 17.0731 9.90961 17.0911 9.7841L17.6056 6.18215L18.8286 7.81273V17.8518Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left">
                      <p>Promociones</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                    <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M0.856506 3.77543C2.46627 1.49719 4.51665 0.219727 7.68228 0.219727C11.0487 0.219727 14.6419 2.80785 14.6419 6.21973C14.6419 9.03741 12.7202 10.1297 11.2672 10.9556C10.3839 11.4576 9.67377 11.8612 9.67377 12.4942V12.7197C9.67377 13.2375 9.24762 13.6572 8.72193 13.6572H5.84772C5.32203 13.6572 4.89588 13.2375 4.89588 12.7197V12.3374C4.89588 9.97999 6.66707 9.00376 8.05825 8.23698C8.09236 8.21818 8.12624 8.1995 8.15987 8.18094C9.36458 7.5157 10.1029 7.06328 10.1029 6.18234C10.1029 5.01703 8.59379 4.24363 7.37368 4.24363C5.82191 4.24363 5.08498 4.94941 4.09154 6.17523C3.76946 6.57266 3.18412 6.64449 2.77272 6.33727L1.06187 5.05957C0.654518 4.75535 0.564489 4.18871 0.856506 3.77543ZM4.53752 17.5139C4.53752 16.0218 5.76995 14.808 7.28481 14.808C8.79966 14.808 10.0321 16.0218 10.0321 17.5138C10.0321 19.0059 8.79966 20.2197 7.28481 20.2197C5.76995 20.2197 4.53752 19.0059 4.53752 17.5139Z" fill="#ABBFCC"/>
                    </svg>
                    </div>
                    <div className="content text-left tutorial-dashboard">
                      <p>¿Cómo funciona mi Dashboard?</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                      <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.856506 3.77543C2.46627 1.49719 4.51665 0.219727 7.68228 0.219727C11.0487 0.219727 14.6419 2.80785 14.6419 6.21973C14.6419 9.03741 12.7202 10.1297 11.2672 10.9556C10.3839 11.4576 9.67377 11.8612 9.67377 12.4942V12.7197C9.67377 13.2375 9.24762 13.6572 8.72193 13.6572H5.84772C5.32203 13.6572 4.89588 13.2375 4.89588 12.7197V12.3374C4.89588 9.97999 6.66707 9.00376 8.05825 8.23698C8.09236 8.21818 8.12624 8.1995 8.15987 8.18094C9.36458 7.5157 10.1029 7.06328 10.1029 6.18234C10.1029 5.01703 8.59379 4.24363 7.37368 4.24363C5.82191 4.24363 5.08498 4.94941 4.09154 6.17523C3.76946 6.57266 3.18412 6.64449 2.77272 6.33727L1.06187 5.05957C0.654518 4.75535 0.564489 4.18871 0.856506 3.77543ZM4.53752 17.5139C4.53752 16.0218 5.76995 14.808 7.28481 14.808C8.79966 14.808 10.0321 16.0218 10.0321 17.5138C10.0321 19.0059 8.79966 20.2197 7.28481 20.2197C5.76995 20.2197 4.53752 19.0059 4.53752 17.5139Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left tutorial-account-statement">
                      <p>¿Cómo leer mi Estado de Cuenta?</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a >
                    <div className="image">
                      <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0.856506 3.77543C2.46627 1.49719 4.51665 0.219727 7.68228 0.219727C11.0487 0.219727 14.6419 2.80785 14.6419 6.21973C14.6419 9.03741 12.7202 10.1297 11.2672 10.9556C10.3839 11.4576 9.67377 11.8612 9.67377 12.4942V12.7197C9.67377 13.2375 9.24762 13.6572 8.72193 13.6572H5.84772C5.32203 13.6572 4.89588 13.2375 4.89588 12.7197V12.3374C4.89588 9.97999 6.66707 9.00376 8.05825 8.23698C8.09236 8.21818 8.12624 8.1995 8.15987 8.18094C9.36458 7.5157 10.1029 7.06328 10.1029 6.18234C10.1029 5.01703 8.59379 4.24363 7.37368 4.24363C5.82191 4.24363 5.08498 4.94941 4.09154 6.17523C3.76946 6.57266 3.18412 6.64449 2.77272 6.33727L1.06187 5.05957C0.654518 4.75535 0.564489 4.18871 0.856506 3.77543ZM4.53752 17.5139C4.53752 16.0218 5.76995 14.808 7.28481 14.808C8.79966 14.808 10.0321 16.0218 10.0321 17.5138C10.0321 19.0059 8.79966 20.2197 7.28481 20.2197C5.76995 20.2197 4.53752 19.0059 4.53752 17.5139Z" fill="#ABBFCC"/>
                      </svg>
                    </div>
                    <div className="content text-left tutorial-manage-cards">
                      <p>¿Cómo administrar mis Tarjetas?</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>  
          {/* modal tutorials */}
          <div>
            <div className="modal modal-statement-welcome modal-tutorial-statement" id="cpr-stm-pda-div-mts" tabIndex="-1" aria-labelledby="cpr-stm-pda-div-mts" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content text-center">
                    <h1></h1>
                    <h3></h3>
                    <div className="row mt-30 justify-content-between">
                      <div className="col-12 col-md-6 col-lg-6 text-right mb-15">
                        <button className="btn btn-primary"></button>
                      </div>
                      <div className="col-12 col-md-6 col-lg-6 text-left">
                        <button className="btn btn-secondary"></button>
                      </div>
                    </div>                 
                  </div>
              </div>
            </div>
            <div className="modal modal-tutorial-filter" id="cpr-stm-pda-div-mtf" tabIndex="-1" role="dialog" aria-labelledby="cpr-stm-pda-div-mtf" aria-hidden="true">
              <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title"></h5>
                    </div>
                    <div className="modal-body">
                      <p></p>
                      <div className="row flex-row-reverse">
                        <div className="col-12 col-lg-6 p-0 mb-15">
                          <span className="btn btn-primary rounded-pill">
                          </span>
                        </div>
                        <div className="col-12 col-lg-6">
                          <a className="link-tutorials"></a>
                        </div>                        
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div className="modal modal-tutorial-transactions" id="cpr-stm-pda-div-mtt" tabIndex="-1" role="dialog" aria-labelledby="cpr-stm-pda-div-mtt" aria-hidden="true">
              <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title"></h5>
                    </div>
                    <div className="modal-body">
                      <p></p>
                      <div className="row flex-row-reverse">
                        <div className="col-12 col-lg-6 p-0 mb-15">
                          <span className="btn btn-primary rounded-pill">
                          </span>
                        </div>
                        <div className="col-12 col-lg-6">
                          <a className="link-tutorials"></a>
                        </div>                        
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div className="modal fade modal-tutorial-questions" id="cpr-stm-pda-div-mtq" tabIndex="-1" aria-labelledby="cpr-stm-pda-div-mtq" aria-hidden="true">
              <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title"></h5>
                    </div>
                    <div className="modal-body">
                      <p></p>
                      <div className="row">
                        <div className="col-lg-6">
                          <a></a>
                        </div>
                        <div className="col-lg-6 text-right">
                          <span className="btn btn-primary btn-exit rounded-pill">
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-9 container-body p-0 mb-15">
            <div className="col-12 mt-30 content-dashboard-title"> 
              <h2 className="d-inline"><i className="fas fa-arrow-left icon-dashboard d-none"></i>Estado de Cuenta FALSO</h2>
            </div>
            <p className="subtitle mt-15">Te invitamos a conocer las transacciones que se han registrado en tu Cuenta Corporativa en los últimos 12 meses. Selecciona a continuación un periodo</p>
            <form className="form-corp" id="cpr-stm-pda-frm-fcp">
              <div className="row mt-15 pb-15 card-basic account" id="cpr-stm-pda-div-acc">
                <div className="col-md-6 col-12 mt-15">
                  <h5>Desde:</h5>
                  <div className="row mt-15 pb-15">
                    <div className="col-md-6 pl-0 group-month-from" id="cpr-stm-pda-div-gmf" data-text="Sólo se permiten consultas de meses previos">
                      <div className="form-group form-group-dropdown mb-0">
                        <label className="select-label">Mes</label>                         
                        <select
                          type="text" 
                          name="Mes"
                          className="custom-select"                                                 
                        >
                          <option  className="custom-select">Mes</option>  
                        </select>                        
                      </div> 
                      <div className="input-group-append">
                        <span className="input-group-text valid"><i className="fas fa-check-circle"></i></span>
                        <span className="input-group-text invalid"><i className="fas fa-times-circle"></i></span>
                      </div> 
                    </div>
                    <div className="col-md-6 pl-0">
                      <div className="form-group form-group-dropdown mb-0">
                        <label className="select-label">Año</label>                         
                        <select
                          type="text" 
                          name="anio"
                          className="custom-select"                           
                        >
                          <option  className="custom-select">Año</option>  
                        </select>                        
                      </div> 
                      <div className="input-group-append">
                        <span className="input-group-text valid"><i className="fas fa-check-circle"></i></span>
                        <span className="input-group-text invalid"><i className="fas fa-times-circle"></i></span>
                      </div>                  
                    </div> 
                  </div>
                </div>
                <div className="col-md-6 col-12 mt-15">
                  <h5>Hasta:</h5>
                  <div className="row mt-15 pb-15">
                    <div className="col-md-6 pl-0">
                      <div className="form-group form-group-dropdown mb-0">
                        <label className="select-label">Mes</label>                         
                        <select
                          type="text" 
                          name="Mes"
                          className=" custom-select"                           
                        >
                          <option  className="custom-select">Mes</option>  
                        </select>                        
                      </div> 
                      <div className="input-group-append">
                        <span className="input-group-text valid"><i className="fas fa-check-circle"></i></span>
                        <span className="input-group-text invalid"><i className="fas fa-times-circle"></i></span>
                      </div> 
                    </div>
                    <div className="col-md-6 pl-0" >
                      <div className="form-group form-group-dropdown mb-0">
                        <label className="select-label">Año</label>                         
                        <select
                           type="text" 
                           name="anio"
                           className="custom-select"                           
                         >
                           <option  className="custom-select">Año</option>  
                        </select>                        
                      </div> 
                      <div className="input-group-append">
                        <span className="input-group-text valid"><i className="fas fa-check-circle"></i></span>
                        <span className="input-group-text invalid"><i className="fas fa-times-circle"></i></span>
                      </div>                  
                    </div> 
                  </div>  
                </div>
                <div className="row w-100" >         
                <div className="col-12 text-right">
                  <button className="btn btn-secondary btn-export mr-15 mt-15" >
                    Exportar
                  </button>
                  <button className="btn btn-primary btn-consult mt-15" >
                    Consultar
                  </button>
                </div>                  
                </div>               
              </div> 
            </form>
            <div className="table-statement-tutorial"> 
              <div className="row container-table-statement mt-15 pb-15 card-basic" data-url="https://corporativo.clubpremier.info/corporate-statement/generate">
                <div className="table-statement-export  col-md-8 col-9 title">
                  <h3 className="mt-15">Transacciones realizadas</h3>
                </div>
                <div className="col-12 col-lg-12">
                  <table className="table table-striped table-statement">
                    <thead>
                      <tr>
                        <th scope="col"><h6 className="mb-0">Fecha de Acred/Reden</h6></th>
                        <th scope="col"><h6 className="mb-0">Fecha de Actividad</h6></th>
                        <th scope="col"><h6 className="mb-0">Empresa afiliada</h6></th>
                        <th scope="col"><h6 className="mb-0">Descripción</h6></th>
                        <th scope="col"><h6 className="mb-0">Puntos Premier</h6></th>
                        <th scope="col"><h6 className="mb-0">Puntos Calificables</h6></th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>   
            </div>    
          </div>
        </div>
      </div>  
    );
  }
}
export default AccountStatement;